import React, { useState } from 'react';
import {
  Tooltip,
  TooltipTrigger,
  TooltipTriggerProps,
} from '@spotify-internal/encore-web';

type Props = {
  id: string;
  overlay: TooltipTriggerProps['overlay'];
};

export const HeldReleasesTableRowTooltip: React.FC<Props> = ({
  id,
  overlay,
  children,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <>
      <TooltipTrigger
        overlay={
          showTooltip && (
            <Tooltip id={id} data-testid={id}>
              {overlay}
            </Tooltip>
          )
        }
        placement={TooltipTrigger.top}
        onShow={() => setShowTooltip(true)}
        onHide={() => setShowTooltip(false)}
      >
        {children}
      </TooltipTrigger>
    </>
  );
};
